import { createClient } from '@supabase/supabase-js'
import type { DigitalCard } from '../types/card'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseKey)

const client = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseKey, {
      auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
    })
  : null

export async function getPublicCard(cardId: string): Promise<DigitalCard> {
  if (!client) throw new Error('Sandhi Card is not connected yet.')

  const { data, error } = await client.rpc('get_public_card', {
    card_identifier: cardId,
  })

  if (error) throw new Error(error.message)
  if (!data) throw new Error('This card is private, unavailable, or the link has expired.')

  const card = data as DigitalCard
  const [profileImageUrl, coverImageUrl] = await Promise.all([
    createCardImageUrl('profileimages', card.profile_image_path),
    createCardImageUrl('coverimages', card.cover_image_path),
  ])

  return {
    ...card,
    profile_image_url: profileImageUrl,
    cover_image_url: coverImageUrl,
  }
}

async function createCardImageUrl(bucket: string, path?: string | null) {
  if (!client || !path) return null
  const { data, error } = await client.storage.from(bucket).createSignedUrl(path, 600)
  if (error) return null
  return data.signedUrl
}
